module.exports = __webpack_public_path__ + "static/media/sample_csv_file.e252b7ab.csv";